// This middleware helps recover from errors when refreshing pages with query parameters
export default defineNuxtRouteMiddleware((to, from) => {
  // Temporarily disabled to prevent conflicts with infinite scroll
  if (process.client) {
    return; // Disabled
  }
  
  // Only run on client side
  if (process.client) {
    // Special handling for vehicles page with query parameters
    if (to.path === '/vehicles') {
      console.log('[Query Recovery] Handling vehicles page:', to.query);
      
      // Store the query in memory for potential recovery
      try {
        // Use window.__INITIAL_QUERY__ for storing the query
        window.__INITIAL_QUERY__ = to.query;
        console.log('[Query Recovery] Stored query parameters in memory:', to.query);
        
        // Check if we have had errors with this URL pattern before
        const errorCount = parseInt(window.__vehiclesPageErrorCount || '0');
        if (errorCount > 2) {
          console.warn('[Query Recovery] Multiple errors detected with vehicles page. Redirecting to clean URL.');
          window.__vehiclesPageErrorCount = '0';
          
          // Force navigate to vehicles page without query parameters
          return navigateTo('/vehicles', { replace: true });
        }
        
        // Set flag to ensure filter data is loaded
        window.__LOAD_FILTER_DATA__ = true;
      } catch (e) {
        console.error('[Query Recovery] Failed to store query in memory:', e);
      }
    }
    
    // Check if we're at the error page and had a previous vehicles query
    if (to.path === '/404' || to.path === '/_nuxt/error' || to.path.includes('error')) {
      try {
        // Increment error counter
        const errorCount = parseInt(window.__vehiclesPageErrorCount || '0');
        window.__vehiclesPageErrorCount = (errorCount + 1).toString();
        
        const savedQuery = window.__INITIAL_QUERY__;
        if (savedQuery) {
          console.log('[Query Recovery] Found saved query parameters, attempting recovery:', savedQuery);
          
          // Redirect to vehicles page with saved query parameters
          return navigateTo({
            path: '/vehicles',
            query: savedQuery
          }, { replace: true });
        }
      } catch (e) {
        console.error('[Query Recovery] Error recovering from saved query:', e);
      }
    }
  }
});

// Add TypeScript declarations
declare global {
  interface Window {
    __INITIAL_QUERY__?: Record<string, any>;
    __vehiclesPageErrorCount?: string;
    __LOAD_FILTER_DATA__?: boolean;
  }
} 